<template>
  <v-app>
    <v-content>
      <vue-tabs-chrome v-model="tabData" :tabs="tabs"
        ><tabs-content>gdfghfgdhfg</tabs-content></vue-tabs-chrome
      >
      <div class="ma-0 pa-0 mt-5"></div>
    </v-content>
  </v-app>
</template>

<script>
//import addFile from "../pages/addFile.vue";
//import viewer from "../components/viewer";

//import notification from "./components/notification";

export default {
  name: "tabs",

  components: {
    //addFile,
    ///viewer,
    //mainLanding,
    //notification
  },

  data() {
    return {
      tab: "google",
      tabData: [
        {
          title: "ismail",
          content: "hlkjhljkh",
        },
        {
          title: "shamsail",
          content: "tityiut",
        },
      ],
      tabs: [
        {
          label: "google",
          key: "google",
          closable: false,
          //favico: require("./assets/google.jpg"),
        },
        {
          label: "facebook",
          key: "facebook",
          //favico: require("./assets/fb.jpg"),
        },
        // {
        //   label: "New Tab",
        //   key: "costom key",
        //   //   favico: (h, { tab, index }) => {
        //   //     return h("span", tab.label);
        //   //   },
        // },
      ],
    };
  },
};
</script>
